import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";
import audienceMembersType from "../types/audienceMembersType";
import errorsType from "../types/errorsType";
import tooltips from "./tooltips";
import {
  SectionTitle,
  Field,
  Label,
  LabelText,
  LabelIcon,
  Required,
  SelectWrapper,
  Error,
  RadioButtonGroup,
  RadioButtonWrapper,
  RadioButton,
  RadioButtonLabel,
  Check,
} from "../styles/edit-form-styles";

const Audience = ({
  audienceMembers,
  audienceMemberIds,
  burst,
  burstOnChange,
  audienceMembersOnChange,
  isLiveOnTheMarketplace,
  errors,
}) => {
  const filteredRecipients = audienceMembers.filter((recipient) =>
    audienceMemberIds.includes(recipient.value)
  );

  return (
    <Fragment>
      <SectionTitle>Audience</SectionTitle>
      <Label>
        <LabelText>
          Audience Members
          <Required>*</Required>
        </LabelText>
        <LabelIcon>
          <FontAwesomeIcon
            data-tip={tooltips.audienceMembers}
            data-for="audience-members-tooltip"
            icon={faInfoCircle}
          />
          <ReactTooltip
            place="left"
            type="dark"
            effect="solid"
            aria-haspopup="true"
            id="audience-members-tooltip"
          />
        </LabelIcon>
      </Label>
      <Field>
        <SelectWrapper>
          <Select
            error={!!errors.audience}
            onChange={(value) => audienceMembersOnChange(value)}
            className="react-select-container"
            classNamePrefix="react-select"
            closeMenuOnSelect={false}
            components={makeAnimated()}
            isMulti
            options={audienceMembers}
            value={filteredRecipients}
            theme={(theme) => ({
              ...theme,
              borderRadius: 4,
              colors: {
                ...theme.colors,
                primary: "#f2008c",
                dangerLight: "#673490",
                primary25: "rgb(242, 0, 140, 0.25)",
                primary50: "rgb(242, 0, 140, 0.5)",
                neutral10: "#673490",
                neutral30: "#f2008c",
                neutral50: "rgb(86, 86, 86)",
                neutral80: "#fff",
              },
            })}
          />
          {errors.audience && <Error positionRelative>{errors.audience}</Error>}
        </SelectWrapper>
      </Field>
      <Label htmlFor="burst" marginTop={20}>
        <LabelText>Is this job currently live on the marketplace?</LabelText>
      </Label>
      <Field infoField>{isLiveOnTheMarketplace ? "Yes" : "No"}</Field>
      {!isLiveOnTheMarketplace ? (
        <Fragment>
          <Label
            htmlFor="burst"
            marginTop={20}
            data-test-id="post-to-the-marketplace"
          >
            <LabelText>
              Do you want to post this job to the marketplace?
            </LabelText>
            <LabelIcon>
              <FontAwesomeIcon
                data-tip={tooltips.burst}
                data-for="burst-tooltip"
                icon={faInfoCircle}
              />
              <ReactTooltip
                place="left"
                type="dark"
                effect="solid"
                aria-haspopup="true"
                id="burst-tooltip"
              />
            </LabelIcon>
          </Label>
          <RadioButtonGroup>
            <RadioButtonWrapper>
              <RadioButton
                onChange={(e) => burstOnChange(e)}
                name="burst"
                id="yes"
                checked={burst === true}
                type="radio"
              />
              <RadioButtonLabel htmlFor="yes">Yes</RadioButtonLabel>
              <Check />
            </RadioButtonWrapper>
            <RadioButtonWrapper>
              <RadioButton
                onChange={(e) => burstOnChange(e)}
                name="burst"
                id="no"
                checked={burst === false}
                type="radio"
              />
              <RadioButtonLabel htmlFor="no">No</RadioButtonLabel>
              <Check />
            </RadioButtonWrapper>
          </RadioButtonGroup>
        </Fragment>
      ) : (
        <Label marginTop={20} data-test-id="contact-manager-message">
          To remove this job from the marketplace, please contact your Account
          Manager.
        </Label>
      )}
    </Fragment>
  );
};

Audience.propTypes = {
  audienceMembers: audienceMembersType.isRequired,
  audienceMemberIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  audienceMembersOnChange: PropTypes.func.isRequired,
  burst: PropTypes.bool.isRequired,
  isLiveOnTheMarketplace: PropTypes.bool.isRequired,
  burstOnChange: PropTypes.func.isRequired,
  errors: errorsType.isRequired,
};

export default Audience;
